module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "app__container"
  }, [_c('div', {
    staticClass: "app__inner"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "app__preview app__side"
  }, [_c('div', {
    staticClass: "app__spinner"
  }, [_c('spinner', {
    attrs: {
      "status": _vm.spinner.status,
      "color": _vm.spinner.color,
      "size": _vm.spinner.size,
      "depth": _vm.spinner.depth,
      "rotation": _vm.spinner.rotation,
      "speed": _vm.spinner.speed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "app__controls"
  }, [_c('div', {
    staticClass: "sl-controls__item"
  }, [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('button', {
    staticClass: "sl-controls__item-ctrl",
    on: {
      "click": function($event) {
        _vm.spinner.status = !_vm.spinner.status
      }
    },
    model: {
      value: (_vm.spinner.status),
      callback: function($$v) {
        _vm.$set(_vm.spinner, "status", $$v)
      },
      expression: "spinner.status"
    }
  }, [_vm._v(_vm._s(_vm.statusMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "sl-controls__item"
  }, [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Size")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spinner.size),
      expression: "spinner.size"
    }],
    staticClass: "sl-controls__item-ctrl",
    attrs: {
      "type": "range",
      "min": "30",
      "max": "150",
      "step": "5",
      "id": "size"
    },
    domProps: {
      "value": (_vm.spinner.size)
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.spinner, "size", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sl-controls__item"
  }, [_c('label', {
    attrs: {
      "for": "depth"
    }
  }, [_vm._v("Depth")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spinner.depth),
      expression: "spinner.depth"
    }],
    staticClass: "sl-controls__item-ctrl",
    attrs: {
      "type": "range",
      "min": "1",
      "max": "10",
      "step": "1",
      "id": "depth"
    },
    domProps: {
      "value": (_vm.spinner.depth)
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.spinner, "depth", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sl-controls__item"
  }, [_c('label', {
    attrs: {
      "for": "color"
    }
  }, [_vm._v("Color")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spinner.color),
      expression: "spinner.color"
    }],
    staticClass: "sl-controls__item-ctrl",
    style: ({
      color: _vm.spinner.color
    }),
    attrs: {
      "type": "text",
      "id": "color"
    },
    domProps: {
      "value": (_vm.spinner.color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.spinner, "color", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sl-controls__item"
  }, [_c('label', {
    attrs: {
      "for": "clockwise"
    }
  }, [_vm._v("Rotation")]), _vm._v(" "), _c('button', {
    staticClass: "sl-controls__item-ctrl",
    on: {
      "click": function($event) {
        _vm.spinner.rotation = !_vm.spinner.rotation
      }
    },
    model: {
      value: (_vm.spinner.rotation),
      callback: function($$v) {
        _vm.$set(_vm.spinner, "rotation", $$v)
      },
      expression: "spinner.rotation"
    }
  }, [_vm._v(_vm._s(_vm.rotationMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "sl-controls__item"
  }, [_c('label', {
    attrs: {
      "for": "speed"
    }
  }, [_vm._v("Speed")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spinner.speed),
      expression: "spinner.speed"
    }],
    staticClass: "sl-controls__item-ctrl __rtl",
    attrs: {
      "type": "range",
      "min": "0.5",
      "max": "2",
      "step": "0.01",
      "id": "speed"
    },
    domProps: {
      "value": (_vm.spinner.speed)
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.spinner, "speed", $event.target.value)
      }
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__info app__side"
  }, [_c('div', {
    staticClass: "app__title"
  }, [_c('h1', [_vm._v("Vue"), _c('br'), _vm._v("Spinner"), _c('br'), _vm._v("Component")])]), _vm._v(" "), _c('div', {
    staticClass: "app__likes"
  }, [_c('a', {
    staticClass: "github-button",
    attrs: {
      "href": "https://github.com/sergeyloysha/vue-spinner-component",
      "data-icon": "octicon-star",
      "data-show-count": "true",
      "aria-label": "Star sergeyloysha/vue-spinner-component on GitHub"
    }
  }, [_vm._v("Star")])]), _vm._v(" "), _c('div', {
    staticClass: "app__sources"
  }, [_c('a', {
    staticClass: "app__btn",
    attrs: {
      "href": "https://github.com/sergeyloysha/vue-spinner-component/archive/master.zip"
    }
  }, [_vm._v("Download")]), _vm._v(" "), _c('a', {
    staticClass: "app__btn app__btn_transparent",
    attrs: {
      "href": "https://github.com/sergeyloysha/vue-spinner-component",
      "target": "_blank"
    }
  }, [_vm._v("Source on Github")])]), _vm._v(" "), _c('div', {
    staticClass: "app__copy"
  }, [_vm._v("\n                    © 2018 Sergey Loysha / "), _c('a', {
    attrs: {
      "href": "//loysha.com",
      "target": "_blank"
    }
  }, [_vm._v("loysha.com")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0a25e2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 16
// module chunks = 0